import React from 'react';
import { Box, useToken } from '@chakra-ui/react';
import { ChevronRight } from 'lucide-react';
import CalendarSVG from '../../CustomSVGs/CalendarSVG';
import { HStack, Pressable, Text } from '@ayble-health/dashboard-components';
import { Badge } from 'components/ui/badge';

type Props = {
  date: string;
  onPress: () => void;
  providerLabel: string;
};

export const VisitBlockCard = ({ date, onPress, providerLabel }: Props) => {
  const [seafoam] = useToken('colors', ['seafoam']);

  return (
    <Pressable onClick={onPress} w={'100%'}>
      <Box w={'100%'}>
        <HStack justifyContent={'space-between'} w={'100%'}>
          <Text
            color={'secondary.500'}
            fontSize={'md'}
            fontWeight={'normal'}
            textAlign={'left'}
          >
            {providerLabel}
          </Text>

          <Badge
            bgColor={'blush'}
            borderColor={'cloud.200'}
            borderWidth={1}
            rounded={'full'}
            px={2}
            py={1}
          >
            <Text color={'seafoam'} fontSize={'xs'} fontWeight={'semibold'}>
              Unscheduled
            </Text>
          </Badge>
        </HStack>

        <HStack alignItems={'center'} justifyContent={'space-between'} mt={2}>
          <HStack alignItems={'center'} gap={1}>
            <CalendarSVG height={12} width={12} />
            <Text color={'blueGray.600'} fontSize={'xs'}>
              Requested on: {date}
            </Text>
          </HStack>

          <ChevronRight color={seafoam} size={16} />
        </HStack>
      </Box>
    </Pressable>
  );
};
